import {Phone, setForm, setFormCheckbox} from "../../form";
import getPageName from "../../getPageName";

const initLeavePageModal = () => {
  if (getPageName() === "marketplaces" || getPageName() === "trade-china" || getPageName() === "marketplaces-pro") return;
  let leavePageModal = document.getElementById("leave-page-modal");
  
  if (!leavePageModal) {
    leavePageModal = document.createElement("div");
    leavePageModal.classList.add("appearing-modal", "custom-modal__hidden");
    if (window.location.pathname === "/program/marketplaces" || window.location.pathname === "/program/marketplace") {
      leavePageModal.classList.add("appearing-modal--form");
    }
    
    leavePageModal.id = "leave-page-modal";
    document.body.append(leavePageModal);
  }

    leavePageModal.innerHTML = `
        <div class="appearing-modal">
          <div class="appearing-modal__wrapper">
                <div class="appearing-modal__left">
                    <div class="appearing-modal__container container">
                        <h2 class="appearing-modal__h2">Начните обучение<br> прямо сейчас</h2>
                        <p class="appearing-modal__subtitle">Самые быстрые получат<br> дополнительную скидку&nbsp;5% при
                            оплате всей стоимости обучения сразу</p>
                    </div>
                </div>
                <div class="appearing-modal__right">
                    <div class="appearing-modal__wrap">
                        <h3 class="appearing-modal__h3">Что вас ждет на&nbsp;программах<br> Академии
                            &laquo;Сигма&raquo;:</h3>
                        <ul class="appearing-modal__ul">
                            <li class="appearing-modal__li">Онлайн-занятия по&nbsp;2&nbsp;часа в&nbsp;день даже
                                с&nbsp;телефона</li>
                            <li class="appearing-modal__li">Лекции и&nbsp;практические занятия в&nbsp;прямом эфире
                            </li>
                            <li class="appearing-modal__li">Портфолио с&nbsp;реальными кейсами</li>
                            <li class="appearing-modal__li">Документ, подтверждающий ваши навыки</li>
                            <li class="appearing-modal__li">Помощь в&nbsp;трудоустройстве: от&nbsp;составления резюме
                                до&nbsp;доступа к&nbsp;чату вакансий</li>
                        </ul>
                        <a href="#form" class="appearing-modal__link btn" data-modal-close>Оставить заявку</a>
                    </div>
                </div>
          </div>
        </div>
    `;
  
  const buttonToForm = leavePageModal.querySelector(".appearing-modal__link"),
    forms = document.querySelectorAll("form");
  let statusModal = false;

  /* Отключение модального окна при заполнении формы */
  if (forms.length > 0) {
    forms.forEach((form) => {
      form.addEventListener("click", () => {
        statusModal = true;
        removeEventOpenModal();
      });
    });
  }

  /* Вывод модального окна при перемещении курсора за пределы сайта */
  const documentLeaveHandle = (evt) => {
    const activeModal = document.querySelector(".custom-modal.active"),
      activeModalJquery = document.querySelector('.jquery-modal');

    if (activeModal || activeModalJquery) return;

    if (!evt.toElement && !evt.relatedTarget) {
      openModalWindow();
    }
  };

  /* Вывод моального окна при неактивности более 10 сек */
  let timeout;
  const eventHandlerHiddenElement = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const activeModal = document.querySelector(".custom-modal.active"),
        activeModalJquery = document.querySelector('.jquery-modal');
  
      if (activeModal || activeModalJquery) return;
      
        openModalWindow();
    }, 9000);
  };

  /* Открытие модального окна */
  function openModalWindow() {
    if (statusModal == true) return;

    statusModal = true;

    let btn = document.querySelector('.modal__open');

    if (!btn) {
      btn = document.createElement('button');
      btn.classList.add('modal__open');
      btn.setAttribute('data-modal-id', 'leave-page-modal');
      btn.setAttribute('data-modal-open', '');
      btn.style.display = 'none';

      document.body.append(btn);
    }

    btn.click();
    btn.remove();
    removeEventOpenModal();

    buttonToForm?.addEventListener("click", () => {
      if (!document.querySelector("#form")) {
        window.location.href = "/#form";
      } else {
        document.querySelector("#form").scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  }

  /* Удаления событий открытия модального окна */
  function removeEventOpenModal() {
    document.removeEventListener("mouseout", documentLeaveHandle);
    document.removeEventListener("mousemove", eventHandlerHiddenElement);
    document.removeEventListener("scroll", eventHandlerHiddenElement);
  }

  /* Запуск событий */
  setTimeout(() => {
    document.addEventListener("mouseout", documentLeaveHandle);
  }, 30000);
 
  document.addEventListener("mousemove", eventHandlerHiddenElement);
  document.addEventListener("scroll", eventHandlerHiddenElement);
};

export default initLeavePageModal;